// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","mainContent":"App_mainContent__mD5IX","sidebar":"App_sidebar__+GFRC"};